import { render, staticRenderFns } from "./settlement-table.vue?vue&type=template&id=1caa0f03"
import script from "./settlement-table.vue?vue&type=script&lang=js"
export * from "./settlement-table.vue?vue&type=script&lang=js"
import style0 from "./settlement-table.vue?vue&type=style&index=0&id=1caa0f03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports